/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { PagedLogList } from '../../models/paged-log-list';

export interface GetLogs2$Params {
   /**
    * Target action (grab, render)
    */
   action?: string;

   /**
    * Provider id (IBM,EPA5,etc)
    */
   providerId?: string;

   /**
    * Status (finished, failed)
    */
   status?: string;

   /**
    * From datetime yyyy-MM-ddThh:mm:ss.zzzzzz (inclusive).
    */
   from?: string;

   /**
    * To datetime yyyy-MM-ddThh:mm:ss.zzzzzz (inclusive).
    */
   to?: string;

   /**
    * Pagination limit.
    */
   start_page?: number;

   /**
    * Pagination offset.
    */
   page_size?: number;
}

export function getLogs2(
   http: HttpClient,
   rootUrl: string,
   params?: GetLogs2$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<PagedLogList>> {
   const rb = new RequestBuilder(rootUrl, getLogs2.PATH, 'get');
   if (params) {
      rb.query('action', params.action, {});
      rb.query('providerId', params.providerId, {});
      rb.query('status', params.status, {});
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('start_page', params.start_page, {});
      rb.query('page_size', params.page_size, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<PagedLogList>;
      })
   );
}

getLogs2.PATH = '/api/log/allLogs';
